// import { Editor } from '@tinymce/tinymce-react';
import { Select, TimePicker, TreeSelect } from 'antd';
import React, { useEffect, useState } from 'react'
import { TreatmentModel, TreatmentType } from '../models/superbit-api-models';
import { SimulatorModel } from '../models/SimulatorModel';
import { CustomerCardModel } from '../models/CustomerCardModel';
import DatePicker from "react-datepicker";
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app-context/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import '../tasks/_TaskAddTask.css';
import { useNavigate } from 'react-router-dom';
import { setReloadLeadTreatments } from '../app-context/leadsSlice';
import _ from 'lodash';
import { DraftEditor } from '../tasks/_DraftEditor';
import moment from 'moment-timezone';
import { setLoadTasks, setReloadSuesTreatments, setTaskStatusNotification } from '../app-context/tasksSlice';

type Props = {
    type: number;
    ClosePopup?: Function;
    showPopUpMessage: (message: string) => void;
    customerId?: string;
};

const dic = {
    "policies": "פוליסות",
    "sues": "תביעות",
    "offers": "הצעות",
    "leads": "לידים",
} as const;

const AddDocumentationTreatmentPopup = (props: Props) => {

    const dispatch = useDispatch();
    const customerModel: CustomerCardModel = new CustomerCardModel();
    const simulatorModel = new SimulatorModel();

    const [timeFormat, setTimeFormat] = useState<string>('HH:mm');

    const [treatmentsData, setTreatmentsData] = useState<any>();
    const [initialData, setInitialData] = useState<any>();

    // const [treatmentsRelations, setTreatmentsRelations] = useState<any>({});
    const [selectedHandler, setSelectedHandler] = useState<string>("");
    const [usersList, setUsersList] = useState<any[]>([]);
    const [insuranceCompaniesList, setInsuranceCompaniesList] = useState<any[]>([]);
    const [companySelected, setCompanySelected] = useState<string>('');
    const [subject, setSubject] = useState<string>('');

    const [chooseRelation, setChooseRelation] = useState<string>('');
    const [treeTreatmentData, setTreeTreatmentData] = useState<any[]>([]);
    const [alertTime, setAlertTime] = useState<string>('00:00');
    const [alertDate, setAlertDate] = useState<string>('');
    const [createTime, setCreateTime] = useState<string>('00:00');
    const [eventDate, setEventDate] = useState<string>('');

    const [bodyContent, setBodyContent] = useState<string>(''); // for doc activities
    const [loadingBodyContent, setLoadingBodyContent] = useState<boolean>(false); // for doc activities

    const [disableDEdit, setDisableDEdit] = useState<boolean>(false);

    const [selectedHandlerError, setSelectedHandlerError] = useState<boolean>(false);
    const [subjectError, setSubjectError] = useState<boolean>(false);

    //For treatments activities
    const [changesList, setChangesList] = useState<string[]>([]);
    const [currentUser, setCurrentUser] = useState<any>({});
    const [aditionalActionList, setAdditionalActionList] = useState<any[]>([]);
    const [showNewAction, setShowNewAction] = useState<boolean>(false);
    const [newAction, setNewAction] = useState<any>({
        date: null,
        owner: '',
        label: '',
        description: ''
    });
    const [insuranceCompanyReadOnly, setInsuranceCompanyReadOnly] = useState<boolean>(false);




    const emailSubjectDetails = useSelector((state: RootState) => state.tasks.emailSubjectDetails);
    const treatmentId = useSelector((state: RootState) => state.tasks.treatmentId);

    const leadIdForTreatment = useSelector((state: RootState) => state.leads.leadIdForTreatment);
    const emailSubjectDetailsForLead = useSelector((state: RootState) => state.leads.emailSubjectDetails);

    const createTreatmentFrom = useSelector((state: RootState) => state.tasks.createTreatmentFrom);

    const phoneNumberOfLead = useSelector((state: RootState) => state.leads.phoneNumberOfLead);

    const sueInsuranceCompanyId = useSelector((state: RootState) => state.sues.sueInsuranceCompanyId);

    const closePopup = (status?: string) => {
        if (props.ClosePopup) {
            props.ClosePopup();
        }
    }

    useEffect(() => {
        init();

    }, []);


    const setRelationsData = (relationDataArg: any) => {
        const relationsData = relationDataArg;
        if (relationsData) {
            if (relationsData.leads && relationsData.leads.length > 0) {
                relationsData.leads.map((lead: any) => {
                    if (lead.offers && lead.offers.length > 0) {
                        let offers = [...lead.offers];
                        relationsData['offers'] = offers;
                    }
                })
            }
            const relationsDataKeys = Object.keys(relationsData);
            const relationsDataList: any[] = [];
            relationsDataKeys.forEach((k: string, idx: number) => {
                console.log('keys', k)
                if (k !== 'policyRelated' && k !== 'leadRelated' && k !== 'sueRelated' && k !== 'open' && k !== 'elementaryInsurancePolicies' &&
                    (k !== 'leads')) {
                    // (createTreatmentFrom.type !== 'lead' || k !== 'leads')) {
                    const relation = relationsData[k];
                    const relationData: any = {
                        title: dic[k as keyof typeof dic] ? dic[k as keyof typeof dic] : k,
                        value: idx,
                        key: idx,
                        selectable: false,
                        type: k,
                    }
                    if (relation && relation.length > 0) {
                        const children = relation.map((c: any, i: number) => {
                            console.log('c', c)
                            return {
                                title: k == 'policies' ? c.policyNumber : k == 'sues' ? c.sueNumber ? c.sueNumber + "-" + c.internalNumber : "0-" + c.internalNumber : k == "leads" ? c.identifier : c.offerIdentity,
                                companyId: k == 'offers' ? c.insuranceCompanyId : '',
                                value: c.id,
                                key: c.id,
                                selectable: true,
                                type: k == 'policies' ? 'policies' : k == 'sues' ? 'sues' : k == 'leads' ? 'leads' : 'offers'
                            }
                        })
                        relationData["children"] = children;
                    }
                    relationsDataList.push(relationData);
                }
            })
            setTreeTreatmentData(relationsDataList);
        }

    }


    const init = async () => {

        const fetchData = async (customerId: any) => {

            let obj = null;
            if (leadIdForTreatment && leadIdForTreatment.length > 0) {
                obj = { leadId: customerId, TreatmentType: 4 }
            } else {
                obj = { customerId: customerId, TreatmentType: 4 }
            }

            const treatmentsData = await customerModel.treatmentsForUpsert(obj);

            if (leadIdForTreatment && leadIdForTreatment.length > 0) {
                treatmentsData.topic = emailSubjectDetailsForLead;
                setSubject(emailSubjectDetailsForLead);
            } else {
                treatmentsData.topic = emailSubjectDetails;
                setSubject(emailSubjectDetails);
            }
            setTreatmentsData(treatmentsData);
            setInitialData(_.cloneDeep(treatmentsData)); // for doc activites

            return treatmentsData;
        }

        const fetchRelationsData = async (customerId: any) => {
             const storedRelations = sessionStorage.getItem(`treatmentsRelations-${customerId}`);
            if (storedRelations) {
                const relationsDataStorage = JSON.parse(storedRelations);
                return relationsDataStorage;
            }

            const relationsData = await customerModel.treatmentsLoadRelations(customerId);
            sessionStorage.setItem(`treatmentsRelations-${customerId}`, JSON.stringify(relationsData));
            console.log('treatmentsLoadRelations- fetchRelationsData-190')
            return relationsData;
        }

        var relationData = null;
        if (props.customerId || treatmentId) {

            if (props.customerId || (leadIdForTreatment && leadIdForTreatment.length > 0)) {
                let idForRelation = props.customerId ? props.customerId : leadIdForTreatment;
                relationData = await fetchRelationsData(idForRelation)
                console.log('relationData', relationData)
                setRelationsData(relationData);
            }

            if (treatmentId && treatmentId.length > 0) {

                const data = await customerModel.getAssignment(treatmentId);
                await customerModel.setAssignmentSeen(treatmentId);

                if (data) {
                    const handlersListStorage = localStorage.getItem('handlersList');
                    if (handlersListStorage) {
                        const handlerListData = JSON.parse(handlersListStorage);
                        const activeHandlerList = handlerListData.filter((h: any) => h.status == 0 && h.id == data.belongsToId);
                        if (activeHandlerList && activeHandlerList.length > 0) {
                            setSelectedHandler(activeHandlerList[0].fullName);
                        } else {
                            setSelectedHandler('');
                        }
                    }
                    try {
                        setEventDate(moment(data.eventDate).format('YYYY-MM-DD'));
                        setCreateTime(moment(data.eventDate).format('HH:mm'));
                        if (data.alertDate) {
                            setAlertDate(moment(data.alertDate).format('YYYY-MM-DD'));
                            setAlertTime(moment(data.alertDate).format('HH:mm'));
                        } else {
                            setAlertTime('00:00');
                        }
                    } catch (error) {
                        setEventDate('');
                        setCreateTime('00:00');
                        setAlertDate('');
                        setAlertTime('00:00');

                    }

                    setSubject(data.topic);

                    setBodyContent(data.emailBody);
                    setLoadingBodyContent(true);

                    // check with sara
                    setChooseRelation(data.policyRelatedId ? data.policyRelatedId : data.offerRelatedId ? data.offerRelatedId : data.sueRelatedId ? data.sueRelatedId : data.leadRelated && data.leadRelatedId ? data.leadRelatedId : '');
                    setCompanySelected(data.companyId ? data.companyId : '');

                    console.log('AddDocumentationTreatmentPopup-createTreatmentFrom', createTreatmentFrom)
                    if (createTreatmentFrom && createTreatmentFrom.type && createTreatmentFrom.id) {
                        if (createTreatmentFrom.type == 'policy') {

                            // setChooseRelation(createTreatmentFrom.id);
                            // data.policyRelatedId = createTreatmentFrom.id;
                            setDisableDEdit(true);
                        }
                        if (createTreatmentFrom.type == 'sue' && createTreatmentFrom.id) {
                            setChooseRelation(createTreatmentFrom.id);
                            data.sueRelatedId = createTreatmentFrom.id;
                            if (createTreatmentFrom.id)
                                data.sueId = createTreatmentFrom.id;
                            setDisableDEdit(true);

                        } else if (createTreatmentFrom.type == 'sign' && createTreatmentFrom.id && createTreatmentFrom.id.length > 0) {
                            setChooseRelation(createTreatmentFrom.id);
                            data.policyRelatedId = createTreatmentFrom.id;
                            setDisableDEdit(true);
                        }
                        if (createTreatmentFrom.type == 'sue' || createTreatmentFrom.type == 'sign') {
                            if (sueInsuranceCompanyId && sueInsuranceCompanyId.length > 0) {
                                data.companyId = sueInsuranceCompanyId;
                                setCompanySelected(sueInsuranceCompanyId);
                                setInsuranceCompanyReadOnly(true);
                            }
                        }
                    }

                    setTreatmentsData(data);

                    setInitialData(_.cloneDeep(data)); // for doc activites


                }
            } else {
                let treatment = await fetchData(props.customerId)

                // set realatedId if create treatment from policy specific so set policy.id from redux and if create from lead set lead.id from redux
                if (createTreatmentFrom && createTreatmentFrom.type && createTreatmentFrom.id) {
                    if (createTreatmentFrom.type == 'policy') {

                        setChooseRelation(createTreatmentFrom.id);
                        treatment.policyRelatedId = createTreatmentFrom.id;
                        setTreatmentsData(treatment);
                        setDisableDEdit(true);
                    }
                    if (createTreatmentFrom.type == 'sue' && createTreatmentFrom.id) {
                        setChooseRelation(createTreatmentFrom.id);
                        treatment.sueRelatedId = createTreatmentFrom.id;
                        treatment.sueId = createTreatmentFrom.id;
                        setDisableDEdit(true);
                        
                    } else if (createTreatmentFrom.type == 'sign' && createTreatmentFrom.id && createTreatmentFrom.id.length > 0) {
                        setChooseRelation(createTreatmentFrom.id);
                        treatment.policyRelatedId = createTreatmentFrom.id;
                        setDisableDEdit(true);
                    }
                    if (createTreatmentFrom.type == 'sue' || createTreatmentFrom.type == 'sign') {
                        if (sueInsuranceCompanyId && sueInsuranceCompanyId.length > 0) {
                            treatment.companyId = sueInsuranceCompanyId;
                            setCompanySelected(sueInsuranceCompanyId);
                            setInsuranceCompanyReadOnly(true);
                        }
                        setTreatmentsData(treatment);
                    }
                }

                // set defualt handler in case of new treatment
                if (treatment) {
                    const loggedUser = localStorage.getItem('loggedUser');
                    let loggedUserData: any = {}
                    if (loggedUser) {
                        loggedUserData = JSON.parse(loggedUser);
                        let handlersList: any[] = [];
                        const handlersListStorage = localStorage.getItem('handlersList');
                        if (handlersListStorage) {
                            handlersList = JSON.parse(handlersListStorage);
                            const loggedUserName = handlersList.find((ul: any) => ul.status == 0 && ul.id == loggedUserData.id);
                            console.log('loggedUserName', loggedUserName)
                            if (loggedUserName) {
                                setSelectedHandler(loggedUserName.fullName);
                                treatment.belongsToId = loggedUserName.id;
                                setTreatmentsData(treatment);
                            }
                        }
                    }

                }

                // setCreateTime(moment(new Date()).format('HH:mm'));
                setCreateTime(moment(new Date()).format('HH:mm'));

                setLoadingBodyContent(true);
            }

        }



        const insuranceCompaniesData = await simulatorModel.getInsuranceCompanies();
        const icTempDataKeys = Object.keys(insuranceCompaniesData);
        const fixedInsuranceCompanies: any[] = [];
        icTempDataKeys.forEach((k: string) => {
            fixedInsuranceCompanies.push({
                value: insuranceCompaniesData[k].description,
                label: insuranceCompaniesData[k].name
            })
        })
        setInsuranceCompaniesList(fixedInsuranceCompanies);


        let handlersList: any[] = [];
        const handlersListStorage = localStorage.getItem('usersList');
        if (handlersListStorage) {
            handlersList = JSON.parse(handlersListStorage);
            const activeHandlerList = handlersList.filter((h: any) => h.status == 0
                && (h.roleId == "4a0a7e1b-7e16-4134-b8b7-de6ef7ad2aec" || h.roleId == "e026af6f-52f0-40b6-b12f-94c546da1725"
                    || h.branchId == "f65ba4e2-8fae-49da-b351-e288a9459f21" || h.branchId == "3b729183-d7a4-49a6-911e-35b63eb0c438"));
            setUsersList(activeHandlerList.map((u: any, i: number) => {
                return {
                    value: u.id,
                    label: u.fullName
                }
            }));

        } else {
            setUsersList([]);
        }

        const savedLoggedUser = localStorage.getItem('loggedUser');
        let loggedUser: any = {}
        if (savedLoggedUser) {
            loggedUser = JSON.parse(savedLoggedUser);
            setCurrentUser(loggedUser);
        }

    }

    const onSelectBelongsTo = (e: any) => {
        const userName = e.target.value;
        const selected = usersList.find((a: any) => a.label == userName);
        console.log('selected', selected)
        let selectHandler = userName;
        // selectHandler = userName;
        setSelectedHandler(selectHandler)
        if (selected) {
            const data = treatmentsData as TreatmentModel;
            data.belongsToId = selected.value;
            setTreatmentsData(data);

            setSelectedHandlerError(false);
        } else {
            // setSelectedHandler("")
            const data = treatmentsData as TreatmentModel;
            data.belongsToId = undefined;
            setTreatmentsData(data);
        }
    }

    const onSelectedHandlerClear = () => {
        const data = treatmentsData as TreatmentModel;
        data.belongsToId = undefined;
        setTreatmentsData(data);
        setSelectedHandler('');
        setSelectedHandlerError(false);
    }


    const onCreateTimeChange = (time: any, timeString: any) => {
        console.log(time, timeString);
        setCreateTime(timeString);
        const data = treatmentsData as TreatmentModel;
        if (data.eventDate) {
            let newDateString = moment(data.eventDate).format('YYYY-MM-DD');
            newDateString += " " + timeString;
            console.log('newDateString', newDateString)
            data.eventDate = new Date(moment(newDateString).format('YYYY-MM-DDTHH:mm'));
            console.log('DateChange', data.eventDate)
            setTreatmentsData(data);
        }
    };


    const onBlurCreateTime = (e: any) => {
        let newTime = e.target.value;
        // add : after 2 chars
        if (!newTime || newTime == '') {
            return;
        }
        newTime = newTime.replace(/(\d{2})(\d)/, '$1:$2');
        setCreateTime(newTime);
        const data = treatmentsData as TreatmentModel;
        if (newTime) {
            let newDateString = moment(data.eventDate).format('YYYY-MM-DD');
            newDateString += "T" + newTime;
            data.eventDate = new Date(moment(newDateString).format('YYYY-MM-DDTHH:mm'));
            setTreatmentsData(data);
        }
    }

    const onCreateDateChange = (newDate: any) => {
        const data = treatmentsData as TreatmentModel;
        let newDateString = moment(newDate).format('YYYY-MM-DD');
        newDateString += " " + createTime;
        if (moment(newDateString).isValid()) {
            data.eventDate = new Date(moment(newDateString).format('YYYY-MM-DDTHH:mm')); //newDate
            setEventDate(moment(newDateString).format('YYYY-MM-DD'));

            setTreatmentsData(data);
        } else {
            data.eventDate = undefined;
            setTreatmentsData(data);
        }
        if (newDate == null || newDate == undefined) {
            data.eventDate = undefined;
            setTreatmentsData(data);
        }
        console.log('DateChange', data.eventDate)
    }

    const onAlertTimeChange = (time: any, timeString: any) => {
        setAlertTime(timeString);
        const data = treatmentsData as TreatmentModel;
        if (data.alertDate) {
            let newDateString = moment(data.alertDate).format('YYYY-MM-DD');
            newDateString += " " + timeString;
            console.log('newDateString', newDateString)
            const tz = "Asia/Jerusalem";
            data.alertDate = new Date(moment(newDateString).tz(tz).format('YYYY-MM-DDTHH:mm'));
            // data.alertDate = new Date(moment(newDateString).format('YYYY-MM-DDTHH:mm'));
            setTreatmentsData(data);
        }
    };

    const onBlurAlertTime = (e: any) => {
        let newTime = e.target.value;
        // add : after 2 chars
        if (!newTime || newTime == '') {
            return;
        }
        newTime = newTime.replace(/(\d{2})(\d)/, '$1:$2');
        setAlertTime(newTime);
        const data = treatmentsData as TreatmentModel;
        if (newTime) {
            let newDateString = moment(data.alertDate).format('YYYY-MM-DD');
            newDateString += "T" + newTime;
            const tz = "Asia/Jerusalem";
            data.alertDate = new Date(moment(newDateString).tz(tz).format('YYYY-MM-DDTHH:mm'));
            // data.alertDate = new Date(moment(newDateString).format('YYYY-MM-DDTHH:mm'));
            setTreatmentsData(data);
        }
    }

    const onAlertDateChange = (newDate: any) => {
        const data = treatmentsData as TreatmentModel;
        let newDateString = moment(newDate).format('YYYY-MM-DD');
        newDateString += " " + alertTime;
        console.log('onAlertDateChange alertTime', alertTime)
        console.log('onAlertDateChange newDateString', newDateString)
        if (moment(newDateString).isValid()) {
            data.alertDate = new Date(moment(newDateString).format('YYYY-MM-DDTHH:mm')); //newDate
            setAlertDate(moment(newDateString).format('YYYY-MM-DD'));

            // set time of now by default when user select date
            setAlertTime(moment(new Date()).format('HH:mm'));

            setTreatmentsData(data);
        } else {
            data.alertDate = undefined;
            setTreatmentsData(data);
        }
        if (newDate == null || newDate == undefined) {
            data.alertDate = undefined;
            setTreatmentsData(data);
        }
        console.log('DateChange', data.alertDate)
    }


    const onSubjectChange = (e: any) => {
        const data = treatmentsData as TreatmentModel;
        const newSubject = e.target.value;
        if (newSubject.length > 0) {
            setSubjectError(false);
        }
        data.topic = newSubject;
        setTreatmentsData(data);
        setSubject(newSubject);
    }


    const onBodyChange = (html: string) => {
        console.log('onBodyChange html', html, bodyContent)
        if (html && html.length > 0) {
            const treatmentTemp = treatmentsData as TreatmentModel;
            treatmentTemp.emailBody = html;
            setTreatmentsData(treatmentTemp);
            setBodyContent(html);


        }
    };

    // const onClear = () => {
    //     const data = treatmentsData as TreatmentModel;
    //     if (data.policyRelatedId) {
    //         data.policyRelatedId = undefined;
    //     }
    //     if (data.leadRelatedId) {
    //         data.leadRelatedId = undefined;
    //     }
    //     if (data.sueRelatedId) {
    //         data.sueRelatedId = undefined;
    //     }
    //     if (data.offerRelatedId) {
    //         data.offerRelatedId = undefined;
    //     }
    //     setChooseRelation('');
    //     setTreatmentsData(data);
    // }

    const onChangeRelations = (v: any) => {
        const data = treatmentsData as any;
        let selectedItem = null;


        if (v == undefined) {
            // data["policyRelatedId"] = undefined;
            // need to check about next line in future
            //data["leadRelatedId"] = undefined;
            // need to check about next line in future *******************$$$$$$$$$$$$$$$$$$***********************
            data["offerRelatedId"] = null;
            // data["sueRelatedId"] = undefined;
            setTreatmentsData(data);
            setChooseRelation('');
            return;
        }

        // need to check whiche branch in tree data treeTreatmentData  is selected if is policies or leads or sues
        for (let i = 0; i < treeTreatmentData.length; i++) {
            let Item = treeTreatmentData[i].children && treeTreatmentData[i].children.length > 0 && treeTreatmentData[i].children.find((a: any) => a.key == v);
            if (Item) {
                console.log('Item', Item)
                selectedItem = Item;
            }
        }

        let newSubjectText = '';

        if (selectedItem) {
            switch (selectedItem.type) {
                case 'policies':
                    data["policyRelatedId"] = v;
                    newSubjectText = `,  פוליסה מספר: ${selectedItem.title}`;
                    break;
                case 'leads':
                    data["leadRelatedId"] = v;
                    newSubjectText = `,  ליד מספר: ${selectedItem.title}`;
                    break;
                case 'offers':
                    data["offerRelatedId"] = v;
                    newSubjectText = `,  הצעה מספר: ${selectedItem.title}`;

                    break;
                case 'sues':
                    data["sueRelatedId"] = v;
                    newSubjectText = `,  תביעה מספר: ${selectedItem.title}`;
                    break;
                default:
            }
        }

        data.topic = data.topic + newSubjectText;
        setSubject(subject + newSubjectText);
        setChooseRelation(v);
        setTreatmentsData(data);
    }

    const onChangeCompany = (value: any) => {
        const companyName = value;
        console.log('value', value)
        const selected = insuranceCompaniesList.find((a: any) => a.value == companyName);
        if (selected) {
            setCompanySelected(selected.label)
            console.log('selected', selected)
            const data = treatmentsData as TreatmentModel;
            data.companyId = selected.value;
            setTreatmentsData(data);
        } else {
            console.log('not selected', selected)

            setCompanySelected(companyName);
            if (companyName == '') {
                const data = treatmentsData as TreatmentModel;
                data.companyId = undefined;
                setTreatmentsData(data);
            }
        }
    }

    const onFileUpload = (event: any) => {
        const fileUploaded = event.target.files[0];
        const fileSize: string = ((fileUploaded.size / 1024) / 1024).toFixed(4);
        if (parseFloat(fileSize) > 5) {
            return;
        }
        const reader = new FileReader();
        if (reader !== undefined && fileUploaded !== undefined) {
            reader.onloadend = () => {
                // const data = treatmentsData;
                // const fileName = (new Date().getTime()) + "_" + fileUploaded.name;
                // if (!data.fileAttachments) {
                //     data.fileAttachments = [];
                // }
                // data.fileAttachments.push(
                //     {
                //         FileName: fileName,
                //         Content: reader.result
                //     }
                // );
                // // const fileChages: any[] = changesList;
                // // fileChages.push('הוסף קובץ ' + fileName);
                // // setChangesList(fileChages);
                // setTreatmentsData(data);

                setTreatmentsData((prev: any) => {
                    const newData = { ...prev };
                    const fileName = (new Date().getTime()) + "_" + fileUploaded.name;

                    if (!newData.fileAttachments) {
                        newData.fileAttachments = [];
                    }

                    newData.fileAttachments.push({
                        FileName: fileName,
                        Content: reader.result
                    });

                    // Update changes list too
                    setChangesList(prevList => [...prevList, 'הוסף קובץ ' + fileName]);

                    return newData;
                });

                // const lead = this.state.Lead;
                // const fileName = (new Date().getTime()) + "_" + fileUploaded.name;
                // lead.carLicenseFile = {
                //     FileName: fileName,
                //     Content: reader.result
                // };
                // const carLicenseFile: any = {
                //     fileName: fileName,
                //     url: null
                // }
                // this.setState({
                //     Lead:lead,
                //     carLicenseFile: carLicenseFile
                // });
            }
            reader.readAsDataURL(fileUploaded);
        }
    };

    const onDeleteAttachment = (index: number) => {
        // const data = treatmentsData as TreatmentModel;
        // if (data.fileAttachments) {
        //     data.fileAttachments.splice(index, 1);
        //     setTreatmentsData(data);
        // }
        setTreatmentsData((prev: any) => {
            const newData = { ...prev };
            if (newData.fileAttachments) {
                newData.fileAttachments.splice(index, 1);
            }
            return newData;
        });
    }

    const onDeleteDocument = (index: number) => {
        const data = treatmentsData as TreatmentModel;
        if (data.treatmentDocuments && data.treatmentDocuments.length > 0 && data.treatmentDocuments[index]) {

            customerModel.customerDocumentsDelete(data.treatmentDocuments[index].id).then((res: any) => {
                // if (res && res.label === "מסמך נמחק בהצלחה!") {
                if (data.treatmentDocuments) {
                    // let fileChages = [];
                    // fileChages = data.treatmentDocuments.filter((f: any, i: number) => i !== index);
                    // console.log('onDeleteDocument-fileChages', fileChages)
                    // data.treatmentDocuments = [...fileChages];
                    // setTreatmentsData(data);
                    setChangesList(prevList => [...prevList, 'נמחק מסמך ' + (
                        data.treatmentDocuments && data.treatmentDocuments[index] ? data.treatmentDocuments[index].fileName : '')]);
                    setTreatmentsData((prev: any) => {
                        const newData = { ...prev };
                        if (newData.treatmentDocuments) {
                            newData.treatmentDocuments.splice(index, 1);
                        }
                        console.log('onDeleteDocument-newData', newData)
                        // Update changes list too
                        // setChangesList(prevList => [...prevList, 'נמחק מסמך ' + (
                        //     data.treatmentDocuments && data.treatmentDocuments[index] ? data.treatmentDocuments[index].fileName : '')]);
                        return newData;
                    });
                }
                // }
            })
        }
    }

    const onSave = async (e: any) => {
        // e.preventDefault();

        let valid = true;
        console.log('onSave selectedHandler', selectedHandler)
        console.log('onSave alertDate', alertDate)
        if ((selectedHandler == '') && (alertDate && alertDate.length > 0)) {
            setSelectedHandlerError(true);
            valid = false;
        }

        const data = treatmentsData as any;
        console.log('treatmentsData.topic', data.topic)
        if (data.topic == null || data.topic == '') {
            console.log('not valid')

            setSubjectError(true);
            valid = false;
        }
        if (!valid) {
            return;
        }

        data["emailBody"] = bodyContent;

        const dataKeys = Object.keys(initialData as TreatmentModel);
        let editHistory = '';
        if (data.id && initialData) {
            const allCustomers = sessionStorage.getItem('allCustomers');
            // const allCustomers = localStorage.getItem('allCustomers');
            let customersList: any[] = [];
            if (allCustomers) {
                customersList = JSON.parse(allCustomers);
            }
            dataKeys.forEach((key: string) => {
                if (key in data && initialData[key as keyof TreatmentModel] && key !== 'treatmentActivities' && key !== 'treatmentDocuments') {
                    console.log('editHistory', editHistory)
                    switch (key) {
                        case 'customerId':
                            const previousUser = customersList.find((a: any) => a.value == initialData.customerId);
                            const currentUserTreatment = customersList.find((a: any) => a.value == data.customerId);
                            if (initialData.customerId === data.customerId) {
                                console.log('same customerId')
                                console.log('customerId', initialData.customerId, data.customerId)
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<b>תיק שונה </b>`;
                            if (previousUser) {
                                editHistory += ` מ-"${previousUser.label}"`;
                            }
                            if (currentUserTreatment) {
                                editHistory += ` ל-"${currentUserTreatment.label}"`;
                            }
                            break;
                        case 'topic': {
                            if (initialData.topic === data.topic) {
                                console.log('same topic')
                                console.log('topic', initialData.topic, data.topic)
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<b>נושא שונה</b>`;
                            editHistory += ` מ-"${initialData.topic}"`;
                            editHistory += ` ל-"${data.topic}"`;

                            break;
                        }
                        case 'companyId': {
                            if (initialData.companyId === data.companyId) {
                                console.log('same companyId')
                                console.log('companyId', initialData.companyId, data.companyId)
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<b>חברה שונה</b>`;
                            const prevCompany = insuranceCompaniesList.find((s: any) => s.value == initialData.companyId)
                            const newCompany = insuranceCompaniesList.find((s: any) => s.value == data.companyId);
                            if (prevCompany) {
                                editHistory += ` מ-"${prevCompany.label}"`;
                            }
                            if (newCompany) {
                                editHistory += ` ל-"${newCompany.label}"`;
                            }
                            if (data.companyId === null) {
                                editHistory += ` ל-""`;
                            }
                            break;
                        }
                        case 'belongsToId': {
                            if (initialData.belongsToId === data.belongsToId) {
                                console.log('same belongsToId')
                                console.log('belongsToId', initialData.belongsToId, data.belongsToId)
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<b>מטפל שונה</b>`;
                            const prevCompanyName = usersList.find((s: any) => s.value == initialData.belongsToId)
                            const newCompanyName = usersList.find((s: any) => s.value == data.belongsToId)
                            if (prevCompanyName) {
                                editHistory += ` מ-"${prevCompanyName.label}"`;
                            }
                            if (newCompanyName) {
                                editHistory += ` ל-"${newCompanyName.label}"`;
                            }
                            break;
                        }
                        case 'eventDate': {
                            if (initialData.eventDate === data.eventDate) {
                                console.log('same eventDate')
                                console.log('eventDate', initialData.eventDate, data.eventDate)
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `יעד סיום שונה`;
                            editHistory += ` מ-"${initialData.eventDate}"`;
                            editHistory += ` ל-"${data.eventDate}"`;
                            break;
                        }
                        case 'alertDate': {
                            if (initialData.alertDate === data.alertDate) {
                                console.log('same alertDate')
                                console.log('alertDate', initialData.alertDate, data.alertDate)
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `יעד סיום שונה`;
                            editHistory += ` מ-"${initialData.alertDate}"`;
                            editHistory += ` ל-"${data.alertDate}"`;
                            break;
                        }
                        case 'emailBody': {
                            if (initialData.emailBody === data.emailBody) {
                                console.log('same emailBody')
                                console.log('emailBody', initialData.emailBody, data.emailBody)
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `הערות שונו`;
                            editHistory += ` ל-"${data.emailBody}"`;
                            break;
                        }
                        // emailBody
                        default:
                            // if(initialData[key] != treatmentData[key]) {
                            //     console.log('onSave data changed', key, 'changed')
                            // }
                            break;
                    }
                }
            })
            if (changesList.length > 0) {
                // console.log('onSave data changed', changesList);
                changesList.forEach((ch: string) => {
                    if (editHistory !== '') {
                        editHistory += "\n";
                    }
                    editHistory += `${ch}`;
                })
            }
            console.log('onSave data changed', editHistory);
        } else {
            editHistory += 'תיעוד הוקם ';
            if (selectedHandler) {
                editHistory += 'לביצוע ע"י ' + selectedHandler + "\n ";
            }
            if (data.emailBody !== '') {
                editHistory += `הערות`;
                editHistory += ` "${data.emailBody}"`;
            } else {

            }
        }
        if (!data.id && data.treatmentActivities) {
            data.treatmentActivities.push({
                createdDate: moment().format('YYYY-MM-DDTHH:mm'),
                topic: 'תיעוד הוקם ',
                note: editHistory.replace(/&nbsp;/g, ' '),
                createdById: currentUser.id
            })
        } else {
            if (!data.treatmentActivities) {
                data.treatmentActivities = [];
            }

            data.treatmentActivities.push({
                createdDate: moment().format('YYYY-MM-DDTHH:mm'),
                topic: 'עדכון תיעוד',
                note: editHistory.replace(/&nbsp;/g, ' '),
                createdById: currentUser.id
            })

        }

        console.log('saveTreatmentDoc data', data);
        const res = await customerModel.treatmentsUpsertTreatment(treatmentsData);
        console.log('saveTreatmentDoc-res', res)
        if (res && res.label === "טיפול שוטף נוצר בהצלחה!" || res.label === "טיפול שוטף עודכן בהצלחה!") {
            dispatch(setTaskStatusNotification(true));
            // reload tasks list
            dispatch(setLoadTasks(true));
            if (treatmentsData.assignmentStatusId != initialData.assignmentStatusId) {
                // if status changed, set taskStatusNotification to true
            }
            // in case create treatment from sue and sue.id is null so save it in local storage for save latter when sue will be saved
            // if(createTreatmentFrom && createTreatmentFrom.type == 'sue' &&
            //      (!createTreatmentFrom.id || createTreatmentFrom.id == null || createTreatmentFrom.id == undefined || createTreatmentFrom.id == '')){
            //         console.log('saveTreatmentDoc-sueTreatmentForSaveLatter', createTreatmentFrom)
            //         console.log('saveTreatmentDoc-sueTreatmentForSaveLatter- treatmentsData', treatmentsData)
            //     const sueLocalStorage = localStorage.getItem('sueTreatmentForSaveLatter');
            //     if(sueLocalStorage){
            //         const sueData = JSON.parse(sueLocalStorage);
            //         if(sueData && sueData.length > 0 && res.val){
            //             treatmentsData["id"] = res.val;
            //             console.log('saveTreatmentDoc-treatmentsDatarst', treatmentsData)
            //             sueData.push(treatmentsData);
            //             localStorage.setItem('sueTreatmentForSaveLatter', JSON.stringify([...sueData]) );
            //         }
            //     } else{
            //         localStorage.setItem('sueTreatmentForSaveLatter', JSON.stringify([treatmentsData]) );
            //     }
            // }

            if (createTreatmentFrom && createTreatmentFrom.type == 'sue') {
                dispatch(setReloadSuesTreatments(true));
            }

            //phoneNumberOfLead
            props.showPopUpMessage('טיפול שוטף מסוג תיעוד נוצר בהצלחה');
            closePopup();

            if (leadIdForTreatment && leadIdForTreatment.length > 0) {
                dispatch(setReloadLeadTreatments(true));
            }

        }
    }


    const onClearNewAction = () => {
        setNewAction({
            date: null,
            owner: '',
            label: '',
            description: ''
        });
        setShowNewAction(false)
    }

    const onSaveNewAction = async () => {
        const currentActionsList = aditionalActionList;
        const action = newAction;
        const data = treatmentsData as TreatmentModel;
        if (!data.treatmentActivities) {
            data.treatmentActivities = [];
        }
        data.treatmentActivities.push({
            createdDate: action.date,
            topic: action.label,
            note: action.description,
            createdById: currentUser.id
        });
        setTreatmentsData(data);
        console.log('onSaveNewAction', currentActionsList);
        // currentActionsList.push(action);
        // setNewAction({
        //     date: null,
        //     owner: '',
        //     label: '',
        //     description: ''
        // });
        // await setAdditionalActionList(currentActionsList);
        setShowNewAction(false)
        console.log('onSaveNewAction', currentActionsList);
    }

    const onNewActionParameterChange = (name: string, value: string | Date) => {
        const action = newAction;
        action[name] = moment(value).format('YYYY-MM-DD HH:mm');
        setNewAction(action);
        console.log('onNewActionParameterChange', name, value, newAction)
    }

    const onNewActionParameterChange2 = async (name: string, event: any) => {
        const newValue = event.target.value;
        const action = newAction;
        action[name] = newValue;
        await setNewAction(action);
        console.log('onNewActionParameterChange', name, newValue, newAction)
    }


    return (
        <div className={`popup-wrapper add-treatment-popup add-task-popup ${props.type}`} style={{ zIndex: 1000 }}>
            <section className="popup-window rtl">
                <div className="close-icon pointer" onClick={(e: any) => closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {'תיעוד'}
                        </div>
                    </div>
                    <div className="popup-body">

                        <div className="parameter-row">
                            <div className={`parameter-item${selectedHandlerError ? ' error' : ''}`}>
                                <div className="field">
                                    <div className="title">
                                        לטיפול ע"י:
                                    </div>
                                    <div className="value">
                                        <input type='text'
                                            list="handler_list"
                                            placeholder='בחר מטפל'
                                            onChange={(e: any) => onSelectBelongsTo(e)}
                                            value={selectedHandler}
                                        />
                                        <datalist id="handler_list">
                                            {usersList && usersList.map((u: any, i: number) => <option key={i} value={u.label}>{u.label}</option>)}
                                        </datalist>
                                        <div className={`icon x-clear pointer ${selectedHandler == '' ? 'hide' : ''}`} onClick={onSelectedHandlerClear}></div>

                                    </div>

                                    {selectedHandlerError && <div className='error-message'>
                                        שדה חובה
                                    </div>}

                                </div>
                            </div>
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        ת. אירוע:
                                    </div>
                                    <div className="value">
                                        <TimePicker
                                            variant="borderless"
                                            onChange={onCreateTimeChange}
                                            onBlur={onBlurCreateTime}
                                            defaultValue={dayjs(createTime, timeFormat)}
                                            value={dayjs(createTime, timeFormat)}
                                            format={timeFormat}
                                            popupClassName='time-picker-time-list'
                                        />

                                        <CompDatePicker
                                            // placeholder={"תאריך התחלה"}
                                            value={treatmentsData && treatmentsData.eventDate ? new Date(treatmentsData.eventDate) : null}
                                            onChange={(e: any) => onCreateDateChange(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        ת. תזכורת
                                    </div>
                                    <div className="value">

                                        <TimePicker
                                            variant="borderless"
                                            onChange={onAlertTimeChange}
                                            onBlur={onBlurAlertTime}
                                            defaultValue={dayjs(alertTime, timeFormat)}
                                            value={dayjs(alertTime, timeFormat)}
                                            format={timeFormat}
                                            popupClassName='time-picker-time-list'
                                        />
                                        <CompDatePicker
                                            // placeholder={"תאריך התחלה"}
                                            value={treatmentsData && treatmentsData.alertDate ? new Date(treatmentsData.alertDate) : null}
                                            onChange={(e: any) => onAlertDateChange(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-row">
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        חברת ביטוח
                                    </div>
                                    <div className="value">
                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder="בחר חברת ביטוח"
                                            defaultValue={''}
                                            value={companySelected}
                                            onChange={onChangeCompany}
                                            options={
                                                insuranceCompaniesList
                                            }
                                            disabled={insuranceCompanyReadOnly}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        שייך ל
                                    </div>
                                    <div className="value">
                                        <TreeSelect
                                            treeLine
                                            placeholder='שייך ל'
                                            showSearch
                                            style={{
                                                width: '100%',
                                            }}
                                            dropdownStyle={{
                                                maxHeight: 400,
                                                overflow: 'auto',
                                            }}
                                            allowClear
                                            onChange={(v: any) => onChangeRelations(v)}
                                            treeData={treeTreatmentData}
                                            value={chooseRelation}
                                            disabled={disableDEdit}
                                        />

                                    </div>
                                    <div className='error-message'>
                                        שדה חובה
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="parameter-row single-item">
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        קובץ מצורף
                                    </div>
                                    <div className="value">
                                        <input type='file' accept="image/png, image/gif, image/jpeg, application/pdf" onChange={onFileUpload} />
                                    </div>
                                    <div className='error-message'>
                                        שדה חובה
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div>
                            {/* fileAttachments */}
                            {treatmentsData && treatmentsData.fileAttachments && treatmentsData.fileAttachments.map((item: any, index: number) => {
                                return (
                                    <div className='item-data-row flex-space-between' style={{ 'padding': '2px 4px 2px 12px' }} key={index}>
                                        <div className='cell' style={{ 'direction': 'ltr' }}>
                                            {item.FileName}
                                        </div>
                                        <div><FontAwesomeIcon className='pointer' icon={faTrash} onClick={() => onDeleteAttachment(index)} /></div>
                                    </div>
                                )
                            })
                            }
                            {treatmentsData && treatmentsData.treatmentDocuments && treatmentsData.treatmentDocuments.map((item: any, index: number) => {
                                const fileUrlData = item.filePath.split("/");
                                const fileName = fileUrlData[fileUrlData.length - 1]
                                return (
                                    <div className={`item-data-row flex-space-between ${item.isDeleted ? 'hide' : ''}`} style={{ 'padding': '2px 4px 2px 12px' }} key={index}>
                                        <div className='cell' style={{ 'direction': 'ltr' }}>
                                            {fileName}
                                        </div>
                                        <div><FontAwesomeIcon className='pointer' icon={faTrash} onClick={() => onDeleteDocument(index)} /></div>
                                    </div>
                                )
                            })
                            }
                        </div>
                        <div className="parameter-row single-item">
                            <div className={`parameter-item${subjectError ? ' error' : ''}`}>
                                <div className="field">
                                    <div className="title">
                                        נושא
                                    </div>
                                    <div className="value">
                                        <input type='text' value={subject} onChange={(e: any) => onSubjectChange(e)} />
                                    </div>
                                    {subjectError && <div className='error-message'>
                                        שדה חובה
                                    </div>}
                                </div>
                            </div>

                        </div>
                        <div className='parameter-row single-item'>
                            <div className={`parameter-item`}>

                                {loadingBodyContent &&
                                    <DraftEditor
                                        initialHtml={bodyContent}
                                        onHtmlChange={(html: string) => onBodyChange(html)}
                                    />
                                }

                            </div>

                        </div>


                        <div className='parameter-row single-item' style={{ marginTop: '10px' }}>
                            <div className='tab-content-title'>
                                פרטים נוספים
                            </div>
                            {/* <button type="button" className="button blue has-icon flex-centered flex-justify-center" onClick={()=>setShowNewAction(true)}>
                                    <div className="icon add"></div>
                                    הוסף פעולה
                                </button> */}
                        </div>
                        <div className='content-table'>
                            <div className='content-header content-table-header client-tasks-list-header'
                            >
                                <div className='cell item-start-date'>
                                    תאריך
                                </div>
                                <div className='cell item-start-date'>
                                    נוצר ע"י
                                </div>
                                <div className='cell item-owner'>
                                    נושא
                                </div>
                                <div className='cell item-details'>
                                    תיאור פעולה
                                </div>
                                <div className='cell item-actions'>
                                </div>
                            </div>
                            <div className='content-table-body'>
                                {showNewAction && newAction && <div className='item-data-row'>
                                    <div className='cell item-start-date'>
                                        <CompDatePicker value={newAction.date} onChange={(date: Date) => onNewActionParameterChange('date', date)} />
                                    </div>
                                    <div className='cell item-owner'>
                                        <input type='text' disabled onChange={(e: any) => onNewActionParameterChange2('owner', e)} />
                                    </div>
                                    <div className='cell item-label'>
                                        <input type='text' onChange={(e: any) => onNewActionParameterChange2('label', e)} />
                                    </div>
                                    <div className='cell item-details'>
                                        <input type='text' onChange={(e: any) => onNewActionParameterChange2('description', e)} />
                                    </div>
                                    <div className='cell item-actions pointer'>
                                        <FontAwesomeIcon icon={faXmark} onClick={onClearNewAction} />
                                        <FontAwesomeIcon icon={faPlus} onClick={onSaveNewAction} />
                                    </div>
                                </div>}
                                {aditionalActionList.map((item: any, index: number) => {
                                    return (
                                        <div className='item-data-row' key={index}>
                                            <div className='cell item-start-date'>
                                                {item.date}
                                            </div>
                                            <div className='cell item-owner'>
                                                {item.owner}
                                            </div>
                                            <div className='cell item-label'>
                                                {item.label}
                                            </div>
                                            <div className='cell item-details'>
                                                {item.description}
                                            </div>
                                            <div className='cell item-actions pointer'>
                                                {/* <FontAwesomeIcon icon={faPen} /> */}
                                                {/* <FontAwesomeIcon icon={faTrash} onClick={()=>onDeleteAction(index)} /> */}
                                            </div>
                                        </div>
                                    )
                                })}
                                {treatmentsData && treatmentsData.treatmentActivities && treatmentsData.treatmentActivities.map((item: any, index: number) => {
                                    const user = usersList.find((a: any) => a.value == item.createdById);

                                    return (
                                        <div className='item-data-row' key={index}>
                                            <div className='cell item-start-date'>
                                                {moment(item.createdDate).format('YYYY-MM-DD HH:mm')}
                                            </div>
                                            <div className='cell item-owner'>
                                                {user && user.label}
                                            </div>
                                            <div className='cell item-label'>
                                                {item.topic}
                                            </div>
                                            <div className='cell item-details' style={
                                                {
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }} title={item.note.replace(/(<([^>]+)>)/gi, '')}>
                                                {/*  dangerouslySetInnerHTML={{ __html: item.note }} */}
                                                {item.note.replace(/(<([^>]+)>)/gi, '')}
                                            </div>
                                            <div className='cell item-actions pointer'>
                                                {/* <FontAwesomeIcon icon={faPen} /> */}
                                                {/* <FontAwesomeIcon className='pointer' icon={faTrash} onClick={()=>onDeleteActivity(index)} /> */}
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>
                        </div>



                    </div>
                    <div className="popup-footer">
                        <button className="button blue pointer" onClick={(e: any) => onSave(e)}>
                            שמור
                        </button>
                        <button className="button white blue-border pointer" onClick={(e: any) => closePopup()}>
                            ביטול
                        </button>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AddDocumentationTreatmentPopup